module.exports = __webpack_public_path__ + "static/img/banner.5c51841.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1st/Articles/Article_8/banner.jpg
// module id = UtyB
// module chunks = 0